import { SidebarSimple } from "@phosphor-icons/react";
import { Button, Sheet, SheetClose, SheetContent } from "@reactive-resume/ui";
import { motion } from "framer-motion";
import { useState } from "react";
import { Outlet } from "react-router-dom";
import { ReloadingWrapper } from "../hooks/context";
import ButtonAppBar from "./_components/app-bar";
import Footer from "./_components/main-footer";
import { Sidebar } from "./_components/sidebar";
import { SidebarProvider, useSidebar } from "./sidebar-context";

const DashboardContent = () => {
  const [open, setOpen] = useState(false);
  const { collapsed } = useSidebar();
  const sidebarWidth = collapsed ? 100 : 220;

  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {/* Mobile sheet trigger */}
      <div className="sticky top-0 z-50 flex items-center justify-between p-4 pb-0 lg:hidden">
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetContent showClose={false} side="left" className="focus-visible:outline-none">
            <SheetClose asChild className="absolute left-4 top-4">
              <Button size="icon" variant="ghost">
                <SidebarSimple />
              </Button>
            </SheetClose>
            <Sidebar setOpen={setOpen} />
          </SheetContent>
        </Sheet>
      </div>

      {/* Desktop sidebar — fixed, full height */}
      <motion.div
        animate={{ width: sidebarWidth }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
        className="hidden lg:fixed lg:inset-y-0 lg:z-50 lg:flex lg:flex-col overflow-visible"
        style={{ width: sidebarWidth }}
      >
        <Sidebar />
      </motion.div>

      {/* Top bar */}
      <div className="sticky top-0 z-40 shrink-0">
        <ButtonAppBar setOpen={setOpen} />
      </div>

      {/* Main content — flex-1 so it grows, but doesn't overflow footer */}
      <motion.main
        animate={{ paddingLeft: sidebarWidth + 32 }}
        style={{ paddingLeft: sidebarWidth + 32 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
        className="my-2 flex-1 overflow-y-auto px-6 lg:px-8 min-h-0"  // ← min-h-0 is key
      >
        <Outlet />
      </motion.main>

      {/* Footer — now actually rendered, shifts with sidebar */}
      <motion.footer
        animate={{ paddingLeft: sidebarWidth }}
        style={{ paddingLeft: sidebarWidth }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
        className="shrink-0 z-40"   // ← shrink-0 prevents flex from squishing it
      >
        <Footer />
      </motion.footer>
    </div>
  );
};

export const DashboardLayout = () => (
  <ReloadingWrapper>
    <SidebarProvider>
      <DashboardContent />
    </SidebarProvider>
  </ReloadingWrapper>
);